import { render } from "./NewCaseTestTubeInfo.vue?vue&type=template&id=ace25770&scoped=true"
import script from "./NewCaseTestTubeInfo.vue?vue&type=script&lang=js"
export * from "./NewCaseTestTubeInfo.vue?vue&type=script&lang=js"

import "./NewCaseTestTubeInfo.vue?vue&type=style&index=0&id=ace25770&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ace25770"],['__file',"src/components/cases/NewCaseTestTubeInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ace25770"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ace25770', __exports__)) {
    console.log('reload')
    api.reload('ace25770', __exports__)
  }
  
  module.hot.accept("./NewCaseTestTubeInfo.vue?vue&type=template&id=ace25770&scoped=true", () => {
    console.log('re-render')
    api.rerender('ace25770', render)
  })

}


export default __exports__